var map = {
	"./ambiente.mp3": "7142",
	"./bg_img.png": "9abe",
	"./bg_new.jpg": "b15f",
	"./bg_visiones.jpg": "d994",
	"./el-espectador.png": "9a52",
	"./ford.png": "a9250",
	"./group_leaves.png": "d54c",
	"./images/pintura.png": "7af2",
	"./images/retrato.png": "6020",
	"./infoamazonia.png": "967c",
	"./logo.png": "cf05",
	"./logo_footer.png": "2f94",
	"./peru_awajun.png": "b905",
	"./peru_awajun_02.png": "2ed5",
	"./peru_awajun_04.png": "80a1",
	"./peru_shipibo_2.png": "6c6b",
	"./picture_01.jpg": "8a34",
	"./picture_02_portada.png": "04ca",
	"./picture_03_portada.png": "0724",
	"./picture_04_portada.png": "e2bf",
	"./picture_05_portada.png": "e178",
	"./picture_06_portada.png": "3aad",
	"./picture_portada.jpg": "360d",
	"./pintura.png": "0dfb",
	"./revista_vistazo.png": "a8f6",
	"./rjf.jpeg": "8d7c",
	"./style.scss": "73ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";